import React from 'react';
import Contragenty from '../../components/spravochniki/contragent/Contragenty'

function ContragentyPage(props) {
    return (
        <>
            <Contragenty />
        </>
    );
}

export default ContragentyPage;